// extracted by mini-css-extract-plugin
export default {"editComment":"styles_edit-comment__svM9i","editComment__buttons":"styles_edit-comment__buttons__7YPoy"};